<template>
  <div class="file-upload">
    <div class="file-upload-drop-area"
         @ondragover="handleFilesUpload()"
         :class="dragging ? 'dropAreaDragging' : ''"
         @dragenter="dragging=true"
         @dragend="dragging=false"
         @dragleave="dragging=false">
      <input type="file" :accept="accept" name="files" ref="files" v-on:change="handleFilesUpload()">

      <h3 class="my-2">
        <i v-if="inProgress" class="mdi mdi-loading mdi-spin mr-1 display-3"></i>
        <i v-else class="mdi mdi-cloud-upload display-3 text-muted"></i><br>
        {{label}}
      </h3>

      <p v-if="value == null">
        Lohista fail siia või <a tabindex>vali fail käsitsi</a>
      </p>

      <strong v-else>
        {{value.name}}
      </strong>
    </div>
    <slot/>
  </div>
</template>

<script>

  export default {
    props: ['accept', 'value', 'label', 'inProgress'],
    data() {
      return {
        dragging: false,
      }
    },
    methods: {
      handleFilesUpload() {
        let file = this.$refs.files.files[0]
        if (this.accept && !this.accept.split(',').find(ext => file.name.endsWith(ext.trim()))) return
        this.$emit('input', file)
      },
    },
  }
</script>
